import { render } from "./QuoteEdit.vue?vue&type=template&id=6b05d70c"
import script from "./QuoteEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./QuoteEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Quote/QuoteEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b05d70c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b05d70c', __exports__)) {
    api.reload('6b05d70c', __exports__)
  }
  
  module.hot.accept("./QuoteEdit.vue?vue&type=template&id=6b05d70c", () => {
    api.rerender('6b05d70c', render)
  })

}


export default __exports__